import { apiClient } from './apiClient';
import type { CustomEmailTemplateSetting } from '../types/customEmailTemplate';

const PATH = '/company-settings/custom-email-template';

export const customEmailTemplateService = {
    get: (): Promise<CustomEmailTemplateSetting> => apiClient.get<CustomEmailTemplateSetting>(PATH),

    /** Replaces the company's whole set: a null language is removed. */
    set: (setting: CustomEmailTemplateSetting): Promise<void> => apiClient.put<void>(PATH, setting),

    remove: (): Promise<void> => apiClient.remove(PATH),
};
